import apiClient from './client';

export const fetchFinancialReport = (params) => apiClient.get('/reports/financial', { params }).then((r) => r.data);
export const financialReportExportUrl = () => `${apiClient.defaults.baseURL}/reports/financial/export`;
export const fetchProjectReport = () => apiClient.get('/reports/projects').then((r) => r.data);
export const fetchEmployeeReport = () => apiClient.get('/reports/employees').then((r) => r.data);
export const employeeReportExportUrl = () => `${apiClient.defaults.baseURL}/reports/employees/export`;
export const fetchClientReport = (clientId) => apiClient.get(`/reports/clients/${clientId}`).then((r) => r.data);
